import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55f8c78e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-details-data" }
const _hoisted_2 = {
  key: 0,
  class: "columns h-100 is-multiline"
}
const _hoisted_3 = { class: "column h-100 is-12-touch is-12-desktop is-6-widescreen" }
const _hoisted_4 = {
  key: 0,
  class: "column h-100 is-12-touch is-12-desktop is-6-widescreen"
}
const _hoisted_5 = {
  key: 1,
  class: "column h-100 is-12-touch is-12-desktop is-6-widescreen"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chart_temperature_humidity = _resolveComponent("chart-temperature-humidity")!
  const _component_chart_lel = _resolveComponent("chart-lel")!
  const _component_chart_ppm = _resolveComponent("chart-ppm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.station && _ctx.measures)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_chart_temperature_humidity, {
              station: _ctx.station,
              since: _ctx.since,
              before: _ctx.before,
              measures: _ctx.measures
            }, null, 8 /* PROPS */, ["station", "since", "before", "measures"])
          ]),
          (!_ctx.inPPM)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_chart_lel, {
                  station: _ctx.station,
                  since: _ctx.since,
                  before: _ctx.before,
                  measures: _ctx.measures
                }, null, 8 /* PROPS */, ["station", "since", "before", "measures"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_chart_ppm, {
                  station: _ctx.station,
                  since: _ctx.since,
                  before: _ctx.before,
                  measures: _ctx.measures
                }, null, 8 /* PROPS */, ["station", "since", "before", "measures"])
              ]))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}